// @flow
import { Map, List } from "immutable"
import fp from "lodash/fp"

import Flight from "common/records/Flight"
import type { PriorityBoardingData } from "booking/services/additionalServices/services/priorityBoarding/services/types"

const CABIN_BAGS_INDEX = "2"

export const calculateHandBagsPrice = (
  handBagsPriceInput: { [string]: number },
  handBagsWithPrioBoardingAllowed: boolean = false,
  pbData: PriorityBoardingData,
  flights: List<Flight>,
) => {
  const handBagsPriceMap = Map(handBagsPriceInput)
  if (!handBagsWithPrioBoardingAllowed) {
    return handBagsPriceMap
  }

  const cabinBaggagePrice = handBagsPriceMap.get(CABIN_BAGS_INDEX) || 0

  const finalPrice = fp.compose(
    fp.reduce(
      (acc, flightId) =>
        acc +
        (fp.getOr(false, [flightId, "is_possible"], pbData)
          ? fp.getOr(0, [flightId, "price"], pbData)
          : 0),
      cabinBaggagePrice,
    ),
    fp.map(flight => flight.id),
    fp.filter(flight => flight.priorityBoarding),
  )(flights.toArray())

  return handBagsPriceMap.set("2", finalPrice)
}
